<!-- Loader principal -->
<div *ngIf="isLoading" class="loader-container">
    <div class="loader-content">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Chargement...</span>
      </div>
      <p class="mt-3 text-muted">Chargement des actualités...</p>
    </div>
  </div>
  
  <!-- Message d'erreur -->
  <div *ngIf="hasError && !isLoading" class="error-container">
    <div class="error-content text-center">
      <i class="ri-error-warning-line error-icon"></i>
      <h5 class="mt-3">Erreur de chargement</h5>
      <p class="text-muted">{{ errorMessage }}</p>
      <button class="btn btn-primary mt-2" (click)="retryLoad()">
        <i class="ri-refresh-line me-2"></i>Réessayer
      </button>
    </div>
  </div>
  
  <!-- Contenu principal - affiché seulement quand chargé -->
  <div *ngIf="!isLoading && !hasError">
    <app-hometwo-banner 
      [data]="bannerData" 
      [spotlightArticle]="spotlightArticle">
    </app-hometwo-banner>
    
    <app-latest-articles></app-latest-articles>
    
    <!--
    <app-featured-shows></app-featured-shows>
    <app-our-sponsors></app-our-sponsors>
    <app-our-hosts></app-our-hosts>
    <app-support-our-channel></app-support-our-channel>
    <app-products></app-products>
    <app-testimonials></app-testimonials>
    -->
    
    <app-blog></app-blog>
    <app-latest-episodes></app-latest-episodes>
    <app-must-watch-episodes></app-must-watch-episodes>
    <app-latest-talent></app-latest-talent>
  </div>